<template>
  <div class="main-nav">
      <ul class="admin-one-ul">
        <li class="admin-one-li" v-for="(item,index) in list" :key="index">
            <a class="admin-one-a" :class="{navActive:navIndex == index}" href="javascript:"  @click.stop ="onShow($event,index)">
                <i :class="['iconfont1','iconfont',item.icon]"></i>
                <span>{{item.name}}</span>
                <i class="iconfont icon-xiangyou"></i>
            </a>
            <ul class="admin-tow-ul" v-if="item.child" :class="{'show-ul':navIndex == index}">
                <li class="admin-tow-li" v-for="(el,i) in item.child" :key="i">
                    <router-link class="admin-tow-a" :class="{navChildActive:`${index}${i}` == `${navIndex}${navChildIndex}`}" :to="'/app/no'" @click.native="select($event,{index:i,url:el.url})">{{el.name}}</router-link>
                </li>
            </ul>
        </li>
    </ul>
  </div>
</template>
<script>
    import bus from "./js/a";
    import {mapActions} from "vuex";
    export default {
        name:"main-nav",
        props:{
            list:Array
        },
        data(){
            return {
                navIndex:0,
                navChildIndex:0,
            }
        },
        mounted(){
            if(sessionStorage.getItem("nav")){
                let nav = JSON.parse(sessionStorage.getItem("nav"))
                this.navIndex = nav.a
                this.navChildIndex = nav.b
            }
            
        },
        watch:{
        },
        methods:{
            ...mapActions(['setTitle']),
            onShow(event,val){
                this.navIndex =val; 
                this.navChildIndex = 0;
                let url;
                if(val == 0){url = "livelyResource"}
                if(val == 1){url = "ditchsbox"}
                if(val == 2){url = "courseChange"}
                if(val == 3){url = "userControl"}
                this.$router.push(`/app/main/${url}`);
                sessionStorage.setItem('nav',`{"a":${this.navIndex},"b":${this.navChildIndex}}`)
                this.setTitle({a:this.navIndex,b:this.navChildIndex})
            },
            select(event,val){
                this.navChildIndex = val.index;
                setTimeout(() => {
                    this.$router.push(val.url)
                }, 1);
                sessionStorage.setItem('nav',`{"a":${this.navIndex},"b":${this.navChildIndex}}`)
                this.setTitle({a:this.navIndex,b:this.navChildIndex})
            }
        }
    }
</script>

<style scoped>



/* main-left */

.admin-one-li {
    border-bottom: 1px #e8e8e8 solid;
}
/* .admin-one-li:last-child {
    border: none;
    pointer-events: none;
} */
.admin-one-a {
    display: flex;
    align-content: center;
    width: 100%;
    line-height: 60px;
    padding-left: 30px;
    font-size: 16px;
    color: #333;
}
.admin-one-a > span {
    padding-left: 12px;
}

.admin-one-a > span + i {
    flex-grow: 1;
    text-align: right;
    padding-right: 12px;
    transition-duration: 600ms;
    opacity: 0;
    transform: translateX(-20px);
}

.navActive .iconfont1,
.navChildActive {
    color: #6699ff !important;
}

.navActive span + i {
    opacity: 1;
    transform: translateX(0)
}

/**二级导航*/
.admin-tow-ul {
    opacity: 0;
    height: 0;
    overflow: hidden;
    transition-duration: 600ms;
}

.admin-tow-a {
    display: block;
    font-size: 14px;
    color: #999;
    padding: 10px 0;
    padding-left: 75px;
}
.show-ul {
    opacity: 1;
    height: auto;
    padding-bottom: 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/main/mainNav.vue